// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Select-module--wrapper--Qs5Lu","select":"Select-module--select--1qWxd","errorMsg":"Select-module--errorMsg--PPRNT"};